<template>
  <section class="privilege-edit">
    <viewTitle
      class="viewTitle"
      :title="viewTitleText"
      :showReturn="true"
    ></viewTitle>

    <!-- main -->
    <section class="main">
      <el-form :label-position="'right'" label-width="120px">
        <el-form-item label="角色名称" class="is-required">
          <div class="form-right-min mid">
            <el-input
              v-model="data.name"
              placeholder="请填写您的角色名称"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="描述">
          <div class="form-right-min mid">
            <el-input
              type="textarea"
              placeholder="可对新增的角色进行描述，便于后续维护"
              v-model="data.description"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="部门权限">
          <div class="form-right-min">
            <span class="admins" v-if="data.admins">
              <el-tag v-for="(item, index) in data.admins" :key="index">{{
                item.admin_name
              }}</el-tag>
            </span>
            <div>
              <template v-for="(items, key) in dept.select">
                <template v-for="(item, index) in items">
                  <User :item="item" :key="key + index" :type="key" />
                </template>
              </template>
              <div class="green pointer" @click="addDept">设置</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="绑定人员" class="is-required">
          <div class="form-right-min">
            <span class="admins" v-if="data.admins">
              <el-tag v-for="(item, index) in data.admins" :key="index">{{
                item.admin_name
              }}</el-tag>
            </span>
            <div>
              <template v-for="(items, key) in number.select">
                <template v-for="(item, index) in items">
                  <User
                    :item="item"
                    :key="key + index"
                    :type="key"
                    :showPhone="numberShowPhone"
                  />
                </template>
              </template>
              <div class="green pointer" @click="addMember">设置</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="操作权限" class="is-required">
          <div class="form-right-min">
            <section v-for="(item, index) in privilegeData" :key="index">
              <p
                class="customerSegmentName"
                v-if="privilegeShow && getPowersKey(item.model).length > 0"
              >
                {{ item.name }}
              </p>
              <section class="choose-privilege outter" v-if="privilegeShow">
                <template v-for="(_module, index) in item.model">
                  <el-row
                    class="module"
                    v-if="getMoudleSelect(_module) || _module.hasChecked"
                    :key="index"
                  >
                    <el-col class="module-title" :span="5">
                      <i
                        style="font-size: 14px;"
                        class="iconfont iconfont-aside"
                        :class="getIcon(_module.name)"
                      ></i>
                      {{ _module.name }}
                    </el-col>
                    <el-col class="child-wrap" :span="18" :offset="1">
                      <el-row
                        class="child"
                        v-for="(menu, index) in _module.menu"
                        :key="index"
                        v-show="menu.hasChecked"
                      >
                        <el-col :span="7" class="child-title">
                          <span>
                            {{ menu.name }}
                          </span>
                        </el-col>
                        <el-col :span="16" :offset="1" class="child-power">
                          <template v-for="(btn, index) in menu.op">
                            <span v-if="btn.checked" :key="index">
                              {{ btn.name }}
                            </span>
                          </template>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </template>
              </section>
            </section>

            <div class="green pointer" @click="addPrivilege">设置</div>
          </div>
        </el-form-item>
      </el-form>
      <div class="form-right-min">
        <el-button type="primary" @click="submitData" size="small">
          保 存
        </el-button>
        <!-- <el-button @click="$router.back()" size="small">
          取 消
        </el-button> -->
      </div>
    </section>

    <!-- 对话框 -->
    <el-dialog
      custom-class="confirm-dialog privilege"
      width="800px"
      :visible.sync="dialogInfo.visible"
      :center="true"
    >
      <header class="title" slot="title">{{ dialogInfo.title }}</header>
      <div class="confirm-main">
        <!-- 操作权限 -->
        <section v-for="(item, index) in dialogInfo.data" :key="index">
          <p class="sec-title">{{ item.name }}</p>
          <section class="choose-privilege">
            <el-row
              class="module"
              type="flex"
              v-for="(_module, index) in item.model"
              :key="index"
            >
              <el-col class="module-title" :span="4">
                <i
                  class="iconfont iconfont-aside"
                  :class="getIcon(_module.name)"
                ></i>
                {{ _module.name }}
              </el-col>
              <el-col class="child-wrap" :span="19" :offset="1">
                <el-row
                  class="child"
                  type="flex"
                  v-for="(menu, index) in _module.menu"
                  :key="index"
                >
                  <el-col :span="5" class="child-title">
                    <span>
                      <el-checkbox
                        @change="
                          val => {
                            handleMenuClick(menu, val);
                          }
                        "
                        v-model="menu.checked"
                        >{{ menu.name }}</el-checkbox
                      >
                    </span>
                  </el-col>
                  <el-col :span="18" :offset="1" class="child-power">
                    <span v-for="(btn, index) in menu.op" :key="index">
                      <el-checkbox
                        @change="
                          val => {
                            checkAllSelect(menu, val);
                          }
                        "
                        v-model="btn.checked"
                        :data-key="btn.button_name"
                        >{{ btn.name }}</el-checkbox
                      >
                    </span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </section>
        </section>
      </div>
      <div class="comfirm-footer" slot="footer">
        <el-button @click="dialogInfo.visible = false" size="small">
          取 消
        </el-button>
        <el-button type="primary" @click="dialogInfo.callback" size="small">
          确 认
        </el-button>
      </div>
    </el-dialog>
    <Dept
      model="org"
      title="组织架构选择"
      :visible="showDept"
      :selected="{
        group: dept.select.group,
        org: dept.select.org,
        user: dept.select.user
      }"
      @confirm="deptConfirm"
      @updateVisible="deptUpdateVisible"
      v-if="deptInitDeptPlugin"
    />
    <Dept
      model="bothAll"
      title="部门人员角色选择"
      :visible="showNumber"
      :selected="{
        group: number.select.group,
        org: number.select.org,
        user: number.select.user
      }"
      :showPhone="numberShowPhone"
      @confirm="numberConfirm"
      @updateVisible="numberUpdateVisible"
      v-if="numberInitDeptPlugin"
    />
  </section>
</template>

<script>
import viewTitle from "@/components/viewTitle";
import Dept from "@/components/qyDept/";
import User from "@/components/qyDept/user";
// import deptUserUrl from "@/components/qyDept/url";
import mixinOrgUrl from "@/components/qyDept/mixinOrgUrl.js";

export default {
  props: {},
  data() {
    return {
      privilegeShow: false,
      isCreate: false,
      dialogInfo: {
        // 1 添加管理员 2 操作权限 3 工会权限
        title: "",
        type: "",
        data: {},
        visible: false,
        callback: () => {
          alert(1);
        }
      },
      outter_is_sync: false,
      inner_is_sync: false,
      // 权限配置
      data: {
        permissions: [],
        department_ids: [],
        bind_user_ids: [],
        name: "",
        description: "",
        powers: []
      },
      // 权限参照表
      privilegeData: {},
      // 已有管理员
      adminList: [],
      showDept: false,
      dept: {
        select: { org: [], group: [], user: [] }
      },
      deptInitDeptPlugin: false,
      showNumber: false,
      numberShowPhone: false,
      number: {
        select: { org: [], group: [], user: [] }
      },
      numberInitDeptPlugin: false,
      orgUrl: {}
    };
  },

  components: {
    Dept,
    User,
    viewTitle
  },
  mixins: [mixinOrgUrl],

  async created() {
    this.orgUrl = await this.mixinOrgUrlSet();
    if (this.group_id) {
      await this.fetchConfig();
      // 获取人员部门初始换数据
      this.getInitData({
        depts: this.data.write_departments
      });
      this.number = {
        select: {
          org: this.data.bind_depts,
          group: this.data.bind_tags,
          user: this.data.bind_users
        }
      };
      this.numberInitDeptPlugin = true;
    } else {
      this.isCreate = true;
      this.deptInitDeptPlugin = true;
      this.numberInitDeptPlugin = true;
    }
    // 获取可配置权限
    await this.fetchData();
  },

  mounted() {},

  computed: {
    group_id() {
      return this.$route.params.id || "";
    },
    unionIds() {
      return this.data.unions.map(item => item.union_id);
    },
    viewTitleText() {
      return this.$route.params.id
        ? "权限管理 / 角色配置 / 修改角色"
        : "权限管理 / 角色配置 / 新增角色";
    }, // 获取已选操作权限
    getPowersKey() {
      return model => {
        console.log(model);
        let ret = [];
        Object.keys(model).forEach(key => {
          let _module = model[key];
          Object.keys(_module.menu).forEach(key => {
            let menu = _module.menu[key];
            menu.op.forEach(item => {
              if (item.checked) {
                ret.push(item.key);
              }
            });
          });
        });
        return ret;
      };
    }
  },

  watch: {},

  methods: {
    getInitData({ depts }) {
      this.$common
        .http({
          mt: "post",
          url: this.orgUrl.getInitData,
          data: {
            depts
          }
        })
        .then(res => {
          this.dept = {
            select: { org: res.data.data.depts, group: [], user: [] }
          };
          // 人员选择器初始化
          this.deptInitDeptPlugin = true;
        });
    },
    numberUpdateVisible(val) {
      this.showNumber = val;
    },
    numberConfirm(obj) {
      for (let key in obj) {
        this.number.select[key] = obj[key];
      }
    },
    addMember() {
      this.showNumber = true;
    },
    deptUpdateVisible(val) {
      this.showDept = val;
    },
    deptConfirm(obj) {
      for (let key in obj) {
        this.dept.select[key] = obj[key];
      }
    },
    addDept() {
      this.showDept = true;
    },
    fetchConfig() {
      return new Promise(resolve => {
        this.$common
          .http({
            mt: "post",
            url: "/api/role/detail",
            data: {
              id: this.group_id
            }
          })
          .then(res => {
            let data = res.data.data;
            data.powers = data.permission.map(item => item.key);
            data.permissions = data.permission.map(item => item.key);
            data.department_ids = data.write_departments;
            data.bind_user_ids = data.bind_users.map(item => item.id);
            data.bind_dept_ids = data.bind_depts.map(item => item.id);
            data.bind_tag_ids = data.bind_tags.map(item => item.id);
            this.privilegeShow = !!data.permission.length;
            this.data = data;
            // this.outter_is_sync = !!Number(this.data.is_sync);
            resolve(data);
          });
      });
    },
    fetchData() {
      return new Promise(resolve => {
        let privilegeData = {};
        this.$common
          .http({
            method: "get",
            url: "/api/permission/list_all",
            data: {}
          })
          .then(res => {
            // privilegeData = res.data.data.qy.model;
            privilegeData = res.data.data;
            // debugger
            this.convertData(privilegeData);
            resolve(this.privilegeData);
          });
      });
    },
    fetchAdminList() {
      this.$common
        .http({
          mt: "post",
          url: "/power/site/admin-list",
          data: {
            is_disable: 0,
            keyword: "",
            page: 1,
            page_size: 99999
          }
        })
        .then(res => {
          let data = res.data.data;
          let { list_item } = data;
          this.adminList = list_item;
        });
    },
    submitData() {
      let data = this.getSubmitData();
      let url = "/api/role/create_and_bind";
      if (this.group_id.length > 0) {
        url = "/api/role/update_and_bind";
      }
      if (data.name.length == 0) {
        this.$common.pcToastFail(`角色名称不能为空`);
        return;
      }
      // if (data.department_ids.length == 0) {
      //   this.$common.pcToastFail(`请选择部门权限`);
      //   return;
      // }
      if (
        data.bind_user_ids.length == 0 &&
        data.bind_dept_ids.length == 0 &&
        data.bind_tag_ids.length == 0
      ) {
        this.$common.pcToastFail(`请选择绑定人员`);
        return;
      }
      if (data.permissions.length == 0) {
        this.$common.pcToastFail(`请选操作权限`);
        return;
      }

      // const requiredKey = {
      //   name: "角色名称",
      //   department_ids: "部门权限",
      //   bind_user_ids: "绑定人员",
      //   permissions: "操作权限"
      // };
      // if(!this.$common.isPass(requiredKey, data)){
      //   return;
      // }
      this.$common
        .http({
          mt: "post",
          url: url,
          data: {
            id: data.id,
            name: data.name,
            description: data.description,
            permissions: data.permissions,
            department_ids: data.department_ids,
            bind_user_ids: data.bind_user_ids,
            bind_dept_ids: data.bind_dept_ids,
            bind_tag_ids: data.bind_tag_ids
          }
        })
        .then(() => {
          this.$common.pcSuccess("保存成功");
          this.$router.back();
        });
    },
    convertData(privilegeDataAll) {
      Object.keys(privilegeDataAll).forEach(keyLv1 => {
        Object.keys(privilegeDataAll[keyLv1].model).forEach(key => {
          let privilegeData = privilegeDataAll[keyLv1].model;
          let _module = privilegeData[key];
          _module.hasChecked = false;
          Object.keys(_module.menu).forEach(key => {
            let menu = _module.menu[key];
            menu.hasChecked = false;
            // 计算是否全选
            menu.checked = false;
            menu.count = 0;
            menu.op.forEach(btn => {
              // 初始化功能的勾选
              if (this.data.powers.indexOf(btn.key) !== -1) {
                btn.checked = true;
                menu.count++;
              } else {
                btn.checked = false;
              }
            });
            menu.checked = menu.count === menu.op.length;
            if (menu.count > 0) {
              menu.hasChecked = true;
              _module.hasChecked = true;
            }
          });
        });
      });
      this.privilegeData = privilegeDataAll;
    },
    addPrivilege() {
      let dialogInfo = this.dialogInfo;
      dialogInfo.title = "绑定操作权限";
      dialogInfo.visible = true;
      dialogInfo.type = "2";
      dialogInfo.data = this.$common.deep(this.privilegeData);

      // 进入创建管理组默认全选
      if (this.isCreate) {
        // this.selectAll(dialogInfo.data, true);
      }

      dialogInfo.callback = () => {
        this.isCreate = false;
        dialogInfo.visible = false;
        this.privilegeData = dialogInfo.data;
        this.privilegeShow = !!this.getPowers().length;
      };
    },
    // 权限设置：计算权是否全选
    checkAllSelect(menu) {
      let checkedItem = menu.op.filter(btn => btn.checked);
      menu.checked = checkedItem.length === menu.op.length;
      menu.hasChecked = !!checkedItem.length;
    },
    // 权限配置：全选按钮点击
    handleMenuClick(menu, val) {
      menu.op.forEach(btn => {
        btn.checked = val;
      });
      menu.hasChecked = val;
      console.log(menu);
    },
    // 权限设置：计算是否需要隐藏某个操作权限模块
    getMoudleSelect(_module) {
      _module.hasChecked = false;
      let hasChecked = false;
      Object.keys(_module.menu).forEach(key => {
        let menu = _module.menu[key];
        if (menu.hasChecked) {
          hasChecked = true;
        }
      });
      return hasChecked;
    },
    getSubmitData() {
      let base_data = this.$common.deep(this.data);
      if (this.group_id.length > 0) {
        base_data.id = this.group_id;
      }
      base_data.department_ids = this.dept.select.org.map(item => item.id);
      base_data.bind_user_ids = this.number.select.user.map(item => item.id);
      base_data.bind_dept_ids = this.number.select.org.map(item => item.id);
      base_data.bind_tag_ids = this.number.select.group.map(item => item.id);
      base_data.permissions = this.getPowers();
      // base_data.is_sync = Number(this.outter_is_sync);
      return base_data;
    },
    // 获取已选操作权限
    getPowers() {
      let ret = [];
      let privilegeDataAll = this.$common.deep(this.privilegeData);
      Object.keys(privilegeDataAll).forEach(keyLv1 => {
        Object.keys(privilegeDataAll[keyLv1].model).forEach(key => {
          let privilegeData = privilegeDataAll[keyLv1].model;
          let _module = privilegeData[key];
          Object.keys(_module.menu).forEach(key => {
            let menu = _module.menu[key];
            menu.op.forEach(item => {
              if (item.checked) {
                ret.push(item.key);
              }
            });
          });
        });
      });
      return ret;
    },
    getIcon(module_name) {
      switch (module_name) {
        case "服务大厅":
          return "icon-home";
        case "相关资讯":
          return "icon-txt";
        case "我是会员":
          return "icon-avatar";
        case "统计分析":
          return "icon-trend";
        case "通用设置":
          return "icon-cog";
        default:
          break;
      }
    },
    selectAll(data, status) {
      for (let moduleKey in data) {
        let theModule = data[moduleKey];
        let theMenu = theModule.menu;
        theModule.hasChecked = status;
        for (let menuKey in theMenu) {
          let menu = theMenu[menuKey];
          menu.checked = status;
          menu.hasChecked = status;
          menu.op.forEach(btn => {
            btn.checked = status;
          });
        }
      }
    }
  }
};
</script>
<style lang="less">
@import "../assets/css/common";
.privilege-edit {
  .main {
    padding: 16px;
    .form-right-min {
      .el-icon-close {
        display: none;
      }
    }
  }
  .el-tag--medium {
    margin-right: 10px;
  }
}
</style>
<style scoped lang="less">
.privilege-edit {
  width: 100%;
  height: 100%;

  box-sizing: border-box;
  .viewTitle {
    padding: 16px 16px 0 16px;
    box-sizing: border-box;
    height: 59px;
    border-bottom: 1px solid #e4e4e4;
  }
  .main {
    overflow: auto;
    height: calc(100% - 59px);
    box-sizing: border-box;
    padding-top: 16px;
    .form-right-min {
      width: 800px;
      margin-left: 20px;
      .el-icon-close {
        display: none;
      }
      &.mid {
        width: 350px;
      }
    }
  }
}
.choose-privilege {
  font-size: 15px;
  text-align: left;
  line-height: 2em;
  padding-left: 4px;
  .module {
    margin-bottom: 14px;
    border-bottom: 1px solid #e4e4e4;
    .child {
      margin-bottom: 10px;
      border-bottom: 1px solid #e4e4e4;
      padding-bottom: 10px;
      &:last-child {
        border: none;
      }
    }
    .child-power {
      & > span {
        display: inline-block;
        width: 146px;
      }
    }
  }
  &.outter {
    padding: 0;
    border-radius: 4px;
    font-size: 14px;
    .module {
      padding: 6px 6px 6px 10px;
      border: 1px solid #e4e4e4;
      .child {
        margin-bottom: 0;
        border: none;
        padding-bottom: 0;
      }
    }
  }
}
.title {
  font-size: 18px;
  text-align: left;
}
.sec-title {
  font-size: 16px;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
.green {
  color: #409eff;
}
.customerSegmentName {
  font-size: 18px !important;
  margin-top: 0;
}
</style>
<style lang="less">
.privilege {
  .main {
    padding: 24px;
  }
  .choose-all {
    border-top: 1px solid #ececec;
    padding: 0 0 4px 4px;
    background: #fff;
    text-align: left;
  }
  .el-dialog__body {
    padding: 0 0 0 20px !important;
    border-bottom: 1px solid #e9e9e9;
    max-height: 600px;
    overflow: auto;
  }
  .el-dialog__footer {
    text-align: right !important;
    padding-top: 30px !important;
  }
  .confirm-main {
    min-height: 200px;
    padding: 0 10px 20px 0 !important;
    border: none !important;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .el-checkbox {
    margin: 0 10px 0 0;
  }
}
</style>
